export type LiveShoppingPlayerEvent = {
  event: string;
  label: string;
  action: string;
};

export interface LiveShoppingTrackParams {
  showId: string;
  interactionType: string;
  id?: string;
  broadcastLength?: number;
  showLength?: number;
}

export const trackLiveShoppingPlayer = ({
  showId,
  interactionType,
  id,
  broadcastLength,
  showLength,
}: LiveShoppingTrackParams): LiveShoppingPlayerEvent => {
  const event = {
    event: 'liveShoppingPlayer',
    label: showId,
    action: generateAction({
      interactionType,
      id,
      broadcastLength,
      showLength,
    }),
  };
  return event;
};

const generateAction = ({
  interactionType,
  id,
  broadcastLength,
  showLength,
}: Omit<LiveShoppingTrackParams, 'showId'>): string => {
  let action = interactionType;

  if (id) {
    action += `|${id}`;
  }

  if (broadcastLength) {
    action += `|${broadcastLength}`;
  }

  if (showLength) {
    action += `|${showLength}`;
  }

  return action;
};
